import { FilterOperatorEnum } from 'domains/appDomain';

export const NUMERIC_OPERATORS = [
  FilterOperatorEnum.EQUALS,
  FilterOperatorEnum.LESS_THAN,
  FilterOperatorEnum.GREATER_THAN,
];

export const MARKUP_OPERATORS = [
  FilterOperatorEnum.EQUALS,
  FilterOperatorEnum.LESS_THAN,
  FilterOperatorEnum.GREATER_THAN,
  FilterOperatorEnum.EXISTS,
  FilterOperatorEnum.NOT_EXISTS,
];

export const isSingleOperator = (op: FilterOperatorEnum) => {
  return (
    op === FilterOperatorEnum.EXISTS || op === FilterOperatorEnum.NOT_EXISTS
  );
};
